import { servicesUrls } from '@/configs/endpoints'
import { SERVICE_TYPE, SUCCESS_CODES } from '@/configs/constants'
import api from '@/plugins/api'

export default {
  state: () => ({
    activeServices: []
  }),
  mutations: {
    SET_DATA_SERVICES(state, data) {
      Object.entries(data).forEach(([key, value]) => {
        state[key] = value
      })
    }
  },
  actions: {
    async getServices({ commit }) {
      try {
        const response = await api.get(servicesUrls.list)
        if (SUCCESS_CODES.includes(response.code)) commit('SET_DATA_SERVICES', { activeServices: response.data || [] })
      } catch (error) {
        console.error('Failed to get services:', error)
      }
    }
  },
  getters: {
    freezeService: state => state.activeServices.find(s => s.type_service === SERVICE_TYPE.FREEZE) || null,
    pauseService: state => state.activeServices.find(s => s.type_service === SERVICE_TYPE.PAUSE) || null
  }
}
